import type { VcsCallModeratorRequest } from 'api';
import { VcsMessagingControllerService } from 'api';
import { type ModeratorApiParams } from 'useCase/moderation/utils/moderatorApi';

const buildBody = (
    roomName: string,
    targetIdentity: string | null,
    targetUserId: string | null,
): VcsCallModeratorRequest & { identity?: string; jwtToken?: string } => ({
    roomName,
    identity: targetIdentity ?? undefined,
    ...(targetUserId != null && targetUserId !== '' && { userId: targetUserId }),
});

/**
 * Вызывает assignSpeakerToCall (OAuth при jwtToken, иначе REST при workspaceId).
 * В meet conference jwt почти всегда есть → обычно *OAuth.
 */
export const assignSpeakerToCallApi = async (params: ModeratorApiParams): Promise<{ success: boolean }> => {
    const { roomName, workspaceId, targetIdentity, targetUserId, jwtToken, isLocalGuest } = params;
    const isValidWorkspaceId = workspaceId != null && workspaceId > 0;
    const body = buildBody(roomName, targetIdentity, targetUserId);

    if (jwtToken) {
        body.jwtToken = jwtToken;
        console.log('[Webinar] assignSpeakerToCallOAuth', { isLocalGuest, workspaceId: workspaceId ?? 'нет' });
        const { error } = await VcsMessagingControllerService.assignSpeakerToCallOAuth(body as VcsCallModeratorRequest);
        if (error) {
            console.warn('[Webinar] assignSpeakerToCallOAuth: ошибка', error);
            return { success: false };
        }
        return { success: true };
    }

    if (isValidWorkspaceId) {
        console.log('[Webinar] assignSpeakerToCall REST', { workspaceId, body });
        const { error } = await VcsMessagingControllerService.assignSpeakerToCall(
            workspaceId as number,
            body as VcsCallModeratorRequest,
        );
        if (error) {
            console.warn('[Webinar] assignSpeakerToCall: ошибка', error);
            return { success: false };
        }
        return { success: true };
    }

    console.warn('[Webinar] assignSpeakerToCall не отправлен: нет workspaceId и нет jwtToken для OAuth.', {
        roomName: !!roomName,
        workspaceId,
        hasJwtToken: !!jwtToken,
    });
    return { success: false };
};

/**
 * Вызывает removeSpeakerFromCall (та же развилка, что у removeModeratorFromCall).
 */
export const removeSpeakerFromCallApi = async (params: ModeratorApiParams): Promise<{ success: boolean }> => {
    const { roomName, workspaceId, targetIdentity, targetUserId, jwtToken, isLocalGuest } = params;
    const isValidWorkspaceId = workspaceId != null && workspaceId > 0;
    const body = buildBody(roomName, targetIdentity, targetUserId);

    if (jwtToken) {
        body.jwtToken = jwtToken;
        console.log('[Webinar] removeSpeakerFromCallOAuth', { isLocalGuest, workspaceId: workspaceId ?? 'нет' });
        const { error } = await VcsMessagingControllerService.removeSpeakerFromCallOAuth(
            body as VcsCallModeratorRequest,
        );
        if (error) {
            console.warn('[Webinar] removeSpeakerFromCallOAuth: ошибка', error);
            return { success: false };
        }
        return { success: true };
    }

    if (isValidWorkspaceId) {
        console.log('[Webinar] removeSpeakerFromCall REST', { workspaceId, body });
        const { error } = await VcsMessagingControllerService.removeSpeakerFromCall(
            workspaceId as number,
            body as VcsCallModeratorRequest,
        );
        if (error) {
            console.warn('[Webinar] removeSpeakerFromCall: ошибка', error);
            return { success: false };
        }
        return { success: true };
    }

    console.warn('[Webinar] removeSpeakerFromCall не отправлен: нет workspaceId и нет jwtToken для OAuth.', {
        roomName: !!roomName,
        workspaceId,
        hasJwtToken: !!jwtToken,
    });
    return { success: false };
};
